import { DynamicEnvironment } from "./dynamic-environment";

/**
 * Client production environment settings.
 */
// export const environment = {
//   production: true,
//   /** Enable console.log or not. */
//   enableConsole: false,
//   apiRootUrl: 'https://B2B-webapi.dynamictire.com/',
//   IAMUrl : 'https://B2B-idp.dynamictire.com/'
// };



class Environment extends DynamicEnvironment {
  public production: boolean;
  // public enableConsole: boolean;
  constructor() {
    super();
    this.production = true;
    // this.enableConsole = false;
  }
}

export const environment = new Environment();
